"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecommendations = exports.getPrograms = exports.combinePrismicData = void 0;

var _reselect = require("reselect");

/* eslint-disable camelcase */
var getRecommendations = function getRecommendations(_ref) {
  var recommendations = _ref.prismic.recommendations;
  return recommendations[0] || {};
};

exports.getRecommendations = getRecommendations;

var getPrograms = function getPrograms(_ref2) {
  var programs = _ref2.prismic.programs;
  return programs || [];
};

exports.getPrograms = getPrograms;
var combinePrismicData = (0, _reselect.createSelector)([getRecommendations, getPrograms], function (recommendations, programs) {
  var recommendationsCopy = {};

  if (recommendations.data && programs.length > 0) {
    recommendationsCopy = recommendations.data;
    recommendationsCopy.programs = recommendationsCopy.programs.reduce(function (acc, _ref3) {
      var _ref3$program = _ref3.program,
          isBroken = _ref3$program.isBroken,
          id = _ref3$program.id;
      var index = programs.findIndex(function (program) {
        return id === program.id;
      });

      if (!isBroken && index >= 0) {
        acc.push(programs[index]);
      }

      return acc;
    }, []);
  }

  return recommendationsCopy;
});
exports.combinePrismicData = combinePrismicData;